module.exports = __webpack_public_path__ + "lib/../sw.js";


// WEBPACK FOOTER //
// ./lib/sw.js